const urlUp = new URL(window.location);

const appConf = {
  baseUrl: window.location.origin,
  debug:
    window.location.hostname.indexOf("localhost") >= 0 ||
    location.port == "8888" ||
    window.location.hostname.indexOf("staging") >= 0 ||
    window.location.href.indexOf("debugit") >= 0 ||
    urlUp.searchParams.get('pass') === "999000"
      ? true
      : false,
  local: window.location.hostname.indexOf("localhost") > -1 ? true : false,
};

export const colors = {
    lBlue: "#7a8396",
    lOrange: "#f49e90",
    blue: "#304052",
    orange: "#ed705a",
    green: "#71755f",
    skt: "#f7d18e",
    mgvUn: "#4a4a4a",
  //  tsvg: "#ffefef",
  tsvg: "#95bb8d",
    zuschlaege: "#71755f",
    brown: "#c6c6c6"
}

colors.anteilLeist = [
  colors.lBlue,
  colors.mgvUn,
  colors.lOrange,
  colors.skt,
  colors.tsvg,
]

colors.fgBttm= [
  colors.lBlue,
  colors.lOrange,
  colors.mgvUn,
  colors.skt,
  colors.tsvg,
  colors.zuschlaege,
]



export default appConf;
